<div class="row justify-content-center align-items-center" mat-dialog-title>
  <div class="col-md-10 col-10">
    <h5 class="text-left txt-primario">Ajustadores</h5>
  </div>
  <div class="col-md-2 col-2 text-right">
    <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
  </div>
</div>
<mat-dialog-content class="py-0">
  <div class="row">
    @if (datoAjustadores.data?.length) {
      <div class="col-md-12 my-4 overflow-auto">
        <table mat-table multiTemplateDataRows [dataSource]="datoAjustadores"
          class="table d-xl-table d-md-table table-responsive my-2">
          <ng-container matColumnDef="No">
            <th mat-header-cell class="px-2" *matHeaderCellDef>No</th>
            <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.cve_consec}}</td>
          </ng-container>
          <ng-container matColumnDef="Nombre">
            <th mat-header-cell class="px-2" *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.nombre}}</td>
          </ng-container>
          <ng-container matColumnDef="Motivo">
            <th mat-header-cell class="px-2" *matHeaderCellDef>Motivo</th>
            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_motivo}}</td>
          </ng-container>
          <ng-container matColumnDef="Fecha">
            <th mat-header-cell class="px-2" *matHeaderCellDef>Fecha</th>
            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.fecha}}</td>
          </ng-container>
          <ng-container matColumnDef="Hora">
            <th mat-header-cell class="px-2" *matHeaderCellDef>Hora</th>
            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.hora}}</td>
          </ng-container>
          <!-- Sin resultados -->
          <ng-container matColumnDef="noData">
            <td mat-footer-cell *matFooterCellDef colspan="5">
              <small>No se encontró ningún resultado</small>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayColumns;  sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="seleccionarAjustador(row)"> </tr>
          <tr mat-footer-row *matFooterRowDef="['noData']"
          [ngClass]="(datoAjustadores?.data?.length === 0) ? '':'ocultarPaginator'"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 20, 50,100]" showFirstLastButtons
          aria-label="Select page of periodic elements">
        </mat-paginator>
      </div>
    } @else {
      <div class="col-md-12">
        <small>No se encontró ningún registro</small>
      </div>
    }
  </div>
</mat-dialog-content>